var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-light pt-3 pt-lg-5 pb-5"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"p-0",attrs:{"cols":"12","lg":"3","xl":"2"}},[_c('DashUserNav')],1),_c('b-col',{staticClass:"pl-3 pl-lg-3 mt-3",attrs:{"cols":"12","lg":"9","xl":"10"}},[_c('h5',{},[_vm._v("Meus cartões")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }